import { effect, Injectable, signal } from '@angular/core';
import { environmnent } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly _isHml = signal(!environmnent.production);

  constructor() {
    effect(() => {
      if (this._isHml()) {
        document.body.classList.add('hml-theme');
      } else {
        document.body.classList.remove('hml-theme');
      }
    });
  }

  isHml() {
    return this._isHml();
  }

  toggleHmlTheme() {
    this._isHml.set(!this._isHml());
  }
}
